import { defineMessages } from 'react-intl';

/** The words of the block rows (design a1, a2, d0, d10, e3). */
export const blockMessages = defineMessages({
  listTitle: { id: 'app.sml.smartlinks.editor.blocks.title', defaultMessage: 'Blocks on the page' },
  addBlock: { id: 'app.sml.smartlinks.editor.blocks.add', defaultMessage: 'Add block' },
  addHere: { id: 'app.sml.smartlinks.editor.blocks.add_here', defaultMessage: 'Add here' },
  dragHandle: { id: 'app.sml.smartlinks.editor.blocks.drag', defaultMessage: 'Move {name}' },
  dragHelp: {
    id: 'app.sml.smartlinks.editor.blocks.drag_help',
    defaultMessage: 'Press Space to pick up. Use the arrow keys to move. Press Space to drop.',
  },
  hide: { id: 'app.sml.smartlinks.editor.blocks.hide', defaultMessage: 'Hide on the page' },
  show: { id: 'app.sml.smartlinks.editor.blocks.show', defaultMessage: 'Show on the page' },
  menu: { id: 'app.sml.smartlinks.editor.blocks.menu', defaultMessage: 'More for {name}' },
  menuEdit: { id: 'app.sml.smartlinks.editor.blocks.menu.edit', defaultMessage: 'Edit' },
  menuUp: { id: 'app.sml.smartlinks.editor.blocks.menu.up', defaultMessage: 'Move up' },
  menuDown: { id: 'app.sml.smartlinks.editor.blocks.menu.down', defaultMessage: 'Move down' },
  menuDuplicate: { id: 'app.sml.smartlinks.editor.blocks.menu.duplicate', defaultMessage: 'Duplicate' },
  menuDelete: { id: 'app.sml.smartlinks.editor.blocks.menu.delete', defaultMessage: 'Delete block' },
  newTag: { id: 'app.sml.smartlinks.editor.blocks.new', defaultMessage: 'New' },
  deleted: { id: 'app.sml.smartlinks.editor.blocks.deleted', defaultMessage: 'Block "{name}" deleted.' },
  deletedSubscribe: {
    id: 'app.sml.smartlinks.editor.blocks.deleted_subscribe',
    defaultMessage: '"Get every release" deleted. Fans who subscribed stay subscribed.',
  },
  undo: { id: 'app.sml.smartlinks.editor.blocks.undo', defaultMessage: 'Undo' },
  deleteFailed: {
    id: 'app.sml.smartlinks.editor.blocks.delete_failed',
    defaultMessage: 'We could not delete "{name}". It is back on the page.',
  },
  saveFailed: {
    id: 'app.sml.smartlinks.editor.blocks.save_failed',
    defaultMessage: 'We could not save the change. Try again.',
  },
  confirmDeleteTitle: {
    id: 'app.sml.smartlinks.editor.blocks.confirm_delete.title',
    defaultMessage: 'Delete Catalog links?',
  },
  confirmDeleteBody: {
    id: 'app.sml.smartlinks.editor.blocks.confirm_delete.body',
    defaultMessage:
      '{count, plural, one {# fan} other {# fans}} pre-saved {title} on this page. They keep the pre-save. The page stops taking new pre-saves.',
  },
  confirmDeleteConfirm: { id: 'app.sml.smartlinks.editor.blocks.confirm_delete.confirm', defaultMessage: 'Delete' },
  // Empty page (design a3).
  startTitle: { id: 'app.sml.smartlinks.editor.start.title', defaultMessage: 'Start with these three' },
  startSub: {
    id: 'app.sml.smartlinks.editor.start.sub',
    defaultMessage: 'Most song pages that get clicks use them. Add one, or all three in one go.',
  },
  startSubBioLink: {
    id: 'app.sml.smartlinks.editor.start.sub_bio_link',
    defaultMessage: 'Most artist pages that get clicks use them. Add one, or all three in one go.',
  },
  startAdd: { id: 'app.sml.smartlinks.editor.start.add', defaultMessage: 'Add' },
  startAddAll: { id: 'app.sml.smartlinks.editor.start.add_all', defaultMessage: 'Add all three' },
  startSeeAll: { id: 'app.sml.smartlinks.editor.start.see_all', defaultMessage: 'See all blocks' },
  startCatalogLinks: {
    id: 'app.sml.smartlinks.editor.start.catalog_links',
    defaultMessage: 'Fans pick their service and play {title}. Before release day they pre-save it.',
  },
  startCatalogLinksNoSong: {
    id: 'app.sml.smartlinks.editor.start.catalog_links_no_song',
    defaultMessage: 'Fans pick their service and play your song. Before release day they pre-save it.',
  },
  startCatalogLinksBio: {
    id: 'app.sml.smartlinks.editor.start.catalog_links_bio',
    defaultMessage: 'Your newest song, playable on every service, right under your name.',
  },
  startPlayer: {
    id: 'app.sml.smartlinks.editor.start.player',
    defaultMessage: 'Fans hear the song before they leave your page.',
  },
  startSocial: {
    id: 'app.sml.smartlinks.editor.start.social',
    defaultMessage: 'Fans follow you in one tap. We fill in your profiles.',
  },
  startProfile: {
    id: 'app.sml.smartlinks.editor.start.profile',
    defaultMessage: 'Fans see who is behind the music: name, photo and bio.',
  },
  // The note after a Bio Link auto add (design e3).
  autoAddNote: {
    id: 'app.sml.smartlinks.editor.auto_add.note',
    defaultMessage: '{title} was added from your Catalog {when}. New songs go {where}.',
  },
  autoAddWhereProfile: { id: 'app.sml.smartlinks.editor.auto_add.where_profile', defaultMessage: 'under your profile' },
  autoAddWhereEnd: { id: 'app.sml.smartlinks.editor.auto_add.where_end', defaultMessage: 'at the end' },
  autoAddChange: { id: 'app.sml.smartlinks.editor.auto_add.change', defaultMessage: 'Change this' },
  autoAddDismiss: { id: 'app.sml.smartlinks.editor.auto_add.dismiss', defaultMessage: 'Close the note' },
});
